module.exports = __webpack_public_path__ + "static/media/sessuologia.7152f5f6.svg";